<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActiveEdit"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-add-new-user-sidebar-active-edit', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <b-card>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Edit Jadwal Wawancara
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <b-form class="mt-2">
      <b-row>
        <!-- <b-col sm="8">
          <b-form-group
            label="Nama Peserta"
            label-for="nama_peserta"
          >
            <b-form-input
              v-model="userData.nama_peserta"
              name="nama_peserta"
              placeholder="Nama Peserta"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="$bvModal.show('bv-modal-cari-peserta-edit')"
          >
            Cari
          </b-button>
        </b-col>
        <div>
          <b-modal id="bv-modal-cari-peserta-edit" size="lg" hide-footer>
            <template #modal-title>
              Cari Akun Peserta
            </template>
            <div class="d-block text-center">
              <pengguna @pilihAkun="pilihAkun" :jenisPencarian="'peserta'" />
            </div>
            <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-cari-peserta')">Close Me</b-button>
          </b-modal>
        </div>

        <b-col sm="8">
          <b-form-group
            label="Nama Pewawancara"
            label-for="nama_pewawancara"
          >
            <b-form-input
              v-model="userData.nama_pewawancara"
              name="nama_pewawancara"
              placeholder="Pewawancara"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="$bvModal.show('bv-modal-cari-pewawancara-edit')"
          >
            Cari
          </b-button>
        </b-col> -->
        <div>
          <b-modal id="bv-modal-cari-pewawancara-edit" size="lg" hide-footer>
            <template #modal-title>
              Cari Akun Pewawancara
            </template>
            <div class="d-block text-center">
              <pengguna @pilihAkun="pilihAkun" :jenisPencarian="'pewawancara'" />
            </div>
            <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-cari-pewawancara')">Close Me</b-button>
          </b-modal>
        </div>

        <b-col sm="12">
          <b-form-group
            label="Tanggal wawancara"
            label-for="tanggal_wawancara"
          >
            <b-form-datepicker v-model="userData.tanggal_wawancara" name="tanggal_wawancara" locale="id"></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Jam wawancara"
            label-for="jam_wawancara"
          >
           <b-form-timepicker v-model="userData.jam" name="tanggal_wawancara" locale="id"></b-form-timepicker>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Tautan wawancara"
            label-for="tautan_wawancara"
          >
            <b-form-input
              v-model="userData.tautan_wawancara"
              name="tautan_wawancara"
              placeholder="Tautan"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              id="radio-group-1"
              v-model="userData.is_daring"
              :options="optionsDaring"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Lokasi wawancara"
            label-for="lokasi_wawancara"
          >
            <b-form-input
              v-model="userData.lokasi_wawancara"
              name="lokasi_wawancara"
              placeholder="Lokasi"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Keterangan"
            label-for="keterangan"
          >
            <b-form-input
              v-model="userData.keterangan"
              name="keterangan"
              placeholder="Keterangan"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" v-if="isDisabled == 'ya'">
        <center>
            <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
            <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
            <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
          </center>
        </b-col>

        <b-col cols="12">
          <b-button
            :disabled="isDisabled == 'ya'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpanData"
          >
            Simpan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
      </b-card>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BRow, BCol,BCard,BFormDatepicker,BFormTimepicker,BModal,BFormRadioGroup,BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/connection-api/data/other/countries'
import store from '@/store'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import Pengguna from '@/views/pages/akun-peserta/list/List.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BFormDatepicker,
    BFormTimepicker,
    BModal,
    Pengguna,
    BFormRadioGroup,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActiveEdit',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActiveEdit: {
      type: Boolean,
      required: true,
    },
    userData: {},
  },
  data() {
    return {
      isDisabled: 'tidak',
      required,
      alphaNum,
      email,
      countries,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      proyekOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Semua' },
        ],
      },
      optionsDaring: [
          { text: 'Daring', value: 'ya' },
          { text: 'Luring', value: 'tidak' },
        ],
    }
  },
  methods: {
    pilihAkun(data){
      if(data.jenis === 'peserta')
      {
        this.userData.peserta_uuid = data.uuid
        this.userData.nama_peserta = data.name
      } else {
        this.userData.pewawancara_uuid = data.uuid
        this.userData.nama_pewawancara = data.name
      }
      this.$emit('reopenForm')
    },
    simpanData() {
      this.isDisabled = 'ya'
      store.dispatch('jadwal-wawancara/updateData', this.userData)
        .then(response => {
          if (response.data.success === true) {
            this.makeToast('success', 'Data berhasil disimpan.')
            this.$emit('refetchData')
            this.userData.nama = null
            this.isDisabled = 'tidak'
            this.$emit('update:is-add-new-user-sidebar-active', false)
          } else {
            this.makeToast('danger', response.data.message)
          }
        })
        .catch(error => {
        })
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Jadwal Wawancara',
        variant,
        solid: true,
        autoHideDelay: 3000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
